module.exports = __webpack_public_path__ + "media/application/images/wjc-horizontal-white-571b148e577a4ce6fea74930c5f2c6c63463b1c6a99ebd0aa507027b65fc688c.svg";